function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-152 -728) translate(152 728)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 26.660156 13.332031 C 26.660156 20.691406 20.691406 26.660156 13.332031 26.660156 C 5.96875 26.660156 0 20.691406 0 13.332031 C 0 5.96875 5.96875 0 13.332031 0 C 20.691406 0 26.660156 5.96875 26.660156 13.332031 Z M 26.660156 13.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.81,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(92.54902%,61.960784%,18.823529%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 6.334962 13.125654 L 10.680646 16.263826 L 15.658466 5.43264 ",
    transform: "matrix(1.218125,0.149567,-0.149567,1.218125,1.722952,-1.54556)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckboxChecked);
export default __webpack_public_path__ + "static/media/ic_checkbox_checked.1b0127b25e61e33deb68a391e13af25b.svg";
export { ForwardRef as ReactComponent };